import AuthenticationCodeDialog from './AuthenticationCodeDialog';
export default AuthenticationCodeDialog;